export default {"src":"/_next/static/media/UNITRA-logo.69aee31c.svg","height":40,"width":172,"blurWidth":0,"blurHeight":0};